import { createBrowserRouter } from 'react-router-dom';
import Home from '../pages/home';
import About from '../pages/about';
import ContactUs from '../pages/contact';
import TermsAndConditions from '../pages/terms-and-conditions';
import PrivacyPolicy from '../pages/privacy-policy';

const routes = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact-us',
    element: <ContactUs />,
  },
  {
    path: '/terms-and-conditions',
    element: <TermsAndConditions />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },

]);

export default routes;
